import {
  ASTheme,
  ASThemeDefault,
  ASResolvedTheme,
  extendASTheme,
} from '@eleventheye/asui';

const fontFamily =
  'var(--nfl-font-family, "Saira Extra Condensed", sans-serif)';

// Charts and navigation still use legacy sections in ASUI 2.15.0.
// Register these as the base so scoped overrides preserve their project defaults.
const chartTheme: ASTheme = {
  ...ASThemeDefault,
  fontFamily: 'Saira Extra Condensed',
  fontFamilyFallback: 'sans-serif',
  chartdonut: {
    ...ASThemeDefault.chartdonut,
    chartdonutTextColor: 'var(--nfl-chart-text, #ffd700)',
    chartdonutInnerTrackColor: 'var(--nfl-chart-inner-track, #595959)',
    chartdonutOuterTrackColor: 'var(--nfl-chart-outer-track, #afafaf)',
  },
};

/** Project-owned theme; team colors remain chart data, not global brand tokens. */
export const nflStatsTheme: ASResolvedTheme = extendASTheme(chartTheme, {
  tokens: { typography: { fontFamily } },
  // Explicit styles bridge legacy recipes, which take precedence over tokens.
  components: {
    button: { fontFamily },
    iconbutton: { fontFamily },
    dropdown: { fontFamily },
    textfield: { fontFamily },
    loader: { fontFamily },
  },
});
